// extracted by mini-css-extract-plugin
export default {"Nickname":"ChatLine_Nickname__ew3HV","text":"ChatLine_text__m6MXR"};